import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { HttpStatusCode } from '@sib/api';
import { Button } from '@sib/ui';
import { PageNotFound as PageNotFoundIcon } from '@sib/ui/icons';
import { paths } from '@spendbrain/config/paths';

export const PageNotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="flex size-full flex-col items-center justify-center gap-4">
      <PageNotFoundIcon
        className="text-primary mb-5 size-36"
        aria-hidden="true"
      />
      <div className="text-primary flex flex-col items-center justify-center gap-10 text-center text-5xl font-medium">
        <p>{HttpStatusCode.NotFound}</p>
        <p>{t('errors.pageNotFound.title')}</p>
      </div>
      <p className="text-muted-foreground mt-5 text-center text-sm">
        {t('errors.pageNotFound.description')}
      </p>
      <Button asChild className="h-10">
        <Link to={paths.dashboard}>
          {t('errors.redirect', { module: t('errors.modules.dashboard') })}
        </Link>
      </Button>
    </div>
  );
};
